import { render, staticRenderFns } from "./SimpleFinance.vue?vue&type=template&id=74ccb675&scoped=true&"
import script from "./SimpleFinance.vue?vue&type=script&lang=js&"
export * from "./SimpleFinance.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFinance.vue?vue&type=style&index=0&id=74ccb675&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ccb675",
  null
  
)

export default component.exports